import R from "ramda";
import parseStringToOject from "./parseStringToOject";

const EDITABLE_TABS = "editable-tabs";

const groupWithIconTypeAndName = R.groupWith((a, b) => {
  const iconA = parseStringToOject(a.icon);
  const iconB = parseStringToOject(b.icon);
  const isSameType = iconA.type === iconB.type;
  const isSameName = iconA.name === iconB.name;
  const isEditableTabs = iconA.type === EDITABLE_TABS;
  return isSameType && isSameName && isEditableTabs;
});

const generateGroupList = R.reduce((accGroups, curGroupList) => {
  const curGroupIcon = parseStringToOject(curGroupList[0].icon);
  const curIconType = curGroupIcon.type || "default";
  const curIconName = curGroupIcon.name || "default";

  return [
    ...accGroups,
    {
      type: curIconType,
      name: curIconName,
      list: R.reduce((accList, cur) => [...accList, cur.name], [])(curGroupList)
    }
  ];
}, []);

export default R.pipe(groupWithIconTypeAndName, generateGroupList);
